<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class="rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">content_with_images</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div>
            <div class="p-2 pb-0 grid grid-cols-12">
              <div class="box col-span-12 p-2 pb-0">
                <p class="label_css">heading</p>
                <textarea v-model="fieldJsonData.heading"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="heading"
                ></textarea>
              </div>
              <div v-if="descriptionEditor === false" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <p class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openDescription()">{{componentDetailsForEdit !== null ? "+ Edit Description" : "+ Add Description"}}</p>
                <p v-if="componentDetailsForEdit !== null" v-html="fieldJsonData.description"></p>
              </div>
              <div v-if="descriptionEditor" class="box col-span-12 p-2 pb-0" v-click-outside="closeDescription">
                <p class="label_css">description</p>
                <editor v-model="fieldJsonData.description"
                placeholder="description"
                ></editor>
              </div>
            </div>
              <div  class="mt-4" style="border: 1px solid gray"></div> 
          </div>
          <div class="py-2 px-1 grid gap-x-2">
            <p class="label_css pl-2 font-bold">content_list_with_images</p>
           <div v-for="(data, index) in fieldJsonData.content_list_with_images" :key="index" class="p-2 pb-0 grid grid-cols-12">
                 <div v-if="tempCardTopDescriptionIndex !== index" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <p class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openCardListTopDescription(index)">{{componentDetailsForEdit !== null ? "+ Edit Top Description" : "+ Add Top Description"}}</p>
                <p v-if="componentDetailsForEdit !== null" v-html="data.top_description"></p>
                </div>
                <div v-if="tempCardTopDescriptionIndex === index && cardTopDescriptionEditor === false" class="box col-span-12 p-2 pb-0">
                    <p class="label_css">top_description</p>
                    <editor v-model="data.top_description"
                    placeholder="top_description"
                    ></editor>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">image_url</p>
                    <input v-model="data.image_url"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="image_url"
                    >
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">image_alt</p>
                    <input v-model="data.image_alt"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="image_alt"
                    >
                </div>
                <div v-if="tempCardBottomDescriptionIndex !== index" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <p class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openCardListBottomDescription(index)">{{componentDetailsForEdit !== null ? "+ Edit Bottom Description" : "+ Add Bottom Description"}}</p>
                <p v-if="componentDetailsForEdit !== null" v-html="data.bottom_description"></p>
                </div>
                <div v-if="tempCardBottomDescriptionIndex === index && cardBottomDescriptionEditor === false" class="box col-span-12 p-2 pb-0">
                    <p class="label_css">bottom_description</p>
                    <editor v-model="data.bottom_description"
                    placeholder="bottom_description"
                    ></editor>
                </div>
               <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeCardDetails(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.content_list_with_images.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addCardDetails()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="fieldJsonData.content_list_with_images.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
import Editor from '../../../../../../components/editor.vue'
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    Editor
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      desc_err: false,
      heading_err: false,
      isError: true,
      descriptionEditor: false,
      tempCardTopDescriptionIndex: null,
      cardTopDescriptionEditor: false,
      tempCardBottomDescriptionIndex: null,
      cardBottomDescriptionEditor: false,
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
    }
  },
  mounted () {
    console.log("@@@@@@@@@@@@@@@@", this.componentId);
  },
  watch: {
  },
  methods: {
    openDescription () {
      this.descriptionEditor = true
    },
    closeDescription () {
      this.descriptionEditor = false
    },
    openCardListTopDescription (index) {
      this.descriptionEditor = false
      this.tempCardTopDescriptionIndex = index
      this.tempCardBottomDescriptionIndex = null
      this.cardBottomDescriptionEditor = false
    },
    openCardListBottomDescription (index) {
      this.descriptionEditor = false
      this.tempCardBottomDescriptionIndex = index
      this.tempCardTopDescriptionIndex = null
      this.cardTopDescriptionEditor = false
    },
    addCardDetails () {
      this.fieldJsonData.content_list_with_images.push({
        top_description: "",
        image_url: "",
        bottom_description: ""
      })
      console.log("addddddd", this.fieldJsonData.content_list_with_images);
    },
    removeCardDetails (index) {
      if (this.fieldJsonData.content_list_with_images.length !== 1) {
        this.fieldJsonData.content_list_with_images.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.content_list_with_images);
    },
    saveData() {
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
    //   if (this.fieldJsonData.description === '') {
    //     this.desc_err = true
    //     this.isError = true
    //   }
    //   if (this.fieldJsonData.heading === '') {
    //     this.heading_err = true
    //     this.isError = true
    //   }
    //   for (let index = 0; index < this.fieldJsonData.content_list_with_images.length; index++) {
    //       if (this.fieldJsonData.content_list_with_images[index].heading === '') {
    //         this.fieldJsonData.content_list_with_images[index].heading_err = true
    //         this.isError = true
    //       }
    //       if (this.fieldJsonData.content_list_with_images[index].description === '') {
    //         this.fieldJsonData.content_list_with_images[index].description_err = true
    //         this.isError = true
    //       }
    //       if (this.fieldJsonData.content_list_with_images[index].top_description === '') {
    //         this.fieldJsonData.content_list_with_images[index].img_url_err = true
    //         this.isError = true
    //       }
    //       if (this.fieldJsonData.content_list_with_images[index].image_url === '') {
    //         this.fieldJsonData.content_list_with_images[index].img_alt_err = true
    //         this.isError = true
    //       }
    //   }
    //   if (this.isError === false) {
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
    //   }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>